import { Injectable } from '@angular/core';
import { FloorTypeModel } from '../../../../core/models/floor-type.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../../../core/base/base.service';
import { DetentionTypeModel } from '../../../../core/models/detention-type.model';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class DetentionTypeService extends BaseService<DetentionTypeModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'detention-type', authService);
  }
}
